import { radius } from './shape'

export interface BadgeProps {
  /** Unread count. Zero renders nothing at all rather than a "0". */
  count: number
  label?: string
  /** Dim is a wash, for a count beside a filled one that asks more of you. */
  tone?: 'filled' | 'dim'
}

/** An unread badge. Blue, because unread is one of the things the accent means. */
export function Badge({ count, label, tone = 'filled' }: BadgeProps) {
  if (count <= 0) return null
  return (
    <span
      aria-label={label ?? `${count} unread`}
      style={{
        minWidth: 16,
        height: 16,
        padding: '0 5px',
        borderRadius: radius.xs,
        background: tone === 'dim' ? 'var(--accent-wash)' : 'var(--accent)',
        color: tone === 'dim' ? 'var(--accent)' : 'var(--ground)',
        font: "600 10px/16px var(--font-machine)",
        textAlign: 'center',
      }}
    >
      {count}
    </span>
  )
}
